/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Pit2_DInputs */

const en_to_csv_pit2_d = /** @type {(inputs: To_Csv_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An object under a key arrives in one cell as JSON text. It is not flattened into columns like user.city, and a spreadsheet will treat it as an opaque string. If you want real columns, flatten the structure in your own code before converting, or convert the nested arrays separately as their own tables.`)
};

const ko_to_csv_pit2_d = /** @type {(inputs: To_Csv_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키 아래의 객체는 JSON 텍스트로 한 칸에 도착합니다. user.city 같은 열로 펼쳐지지 않으며, 스프레드시트는 이를 불투명한 문자열로 취급합니다. 실제 열이 필요하면 변환 전에 코드에서 구조를 펼치거나, 중첩 배열을 별도 표로 따로 변환하세요.`)
};

const ja_to_csv_pit2_d = /** @type {(inputs: To_Csv_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーの下のオブジェクトは JSON テキストとして 1 つのセルに届きます。user.city のような列に展開されず、表計算は不透明な文字列として扱います。本物の列が欲しいなら、変換前に自分のコードで構造を平坦化するか、ネストした配列を独自の表として別に変換してください。`)
};

/**
* | output |
* | --- |
* | "An object under a key arrives in one cell as JSON text. It is not flattened into columns like user.city, and a spreadsheet will treat it as an opaque string...." |
*
* @param {To_Csv_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_pit2_d = /** @type {((inputs?: To_Csv_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_pit2_d(inputs)
	if (locale === "ko") return ko_to_csv_pit2_d(inputs)
	return ja_to_csv_pit2_d(inputs)
});